import React, { FC } from 'react';
import { Box, Stack, Typography, colors } from '@mui/material';
import { Button } from 'reactstrap';

// components
import ContentSection from 'src/components/content/content-section';
import ContentWrapper from 'src/components/content/content-wrapper';
import Popup from 'src/components/content/popup/popup';

// types & utils
import { useViewport } from 'src/lib/utils';

// styles & assets
import styles from './changePlanPopup.module.scss';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { ChallengePlanSelection } from 'src/pages/subscription-new/components/challenge-package/ChallengePlanSelection';
import {
  setChallengePlan,
  setSelectedPlanId,
  resetProteinFlavor,
  resetShippingAddress,
} from 'src/store/signup';
import { mergeChallengePlans } from 'src/pages/subscription-new/utils/plans.util';
import { useChallengeProducts } from 'src/pages/subscription-new/hooks/useChallengeProducts';
import { getChallengeBundlePlans } from 'src/pages/subscription-new/utils/challengeBundle.util';

interface PopupProps {
  setPopupVisible: (val: boolean) => void;
}

export const ChangeChallengePlanModal: FC<PopupProps> = ({
  setPopupVisible,
}) => {
  const dispatch = useAppDispatch();
  const { isMobile } = useViewport();

  const {
    selectedPlanId,
    challengePackageSelectedPlan,
    allPlansSorted,
    isChallengeBundleFlow,
  } = useAppSelector(state => state.signUp);

  const { challengeStartDate, challengeData } = useChallengeProducts();

  const mergedChallengePlans = mergeChallengePlans(
    allPlansSorted,
    challengeStartDate,
    challengeData?.asset_metadata
  );
  const challengeBundlePlans = getChallengeBundlePlans(
    allPlansSorted,
    challengeData?.asset_metadata,
    true
  );
  const flowPlans = isChallengeBundleFlow
    ? challengeBundlePlans
    : mergedChallengePlans;

  const onConfirm = () => {
    setPopupVisible(false);
    if (challengePackageSelectedPlan?.id) {
      dispatch(
        setSelectedPlanId(
          challengePackageSelectedPlan?.checkoutPlanId ??
            challengePackageSelectedPlan?.id
        )
      );
      dispatch(resetProteinFlavor());
      dispatch(resetShippingAddress());
    }
  };

  const onClose = () => {
    setPopupVisible(false);
    const plan = flowPlans.find(
      p => (p.checkoutPlanId ?? p.id) === selectedPlanId
    );
    if (plan) {
      dispatch(setChallengePlan(plan));
    }
  };

  return (
    <Popup style={{ backgroundColor: colors.cyan }}>
      <ContentWrapper className={styles.background} collapseAt="sm">
        <ContentSection className={styles.subscriptionPopup} collapseAt="sm">
          <Stack gap={'16px'} alignItems={'center'}>
            <Button className={styles.close} onClick={onClose} />

            <Typography
              fontSize={isMobile ? '20px' : '29px'}
              my={'16px'}
              textAlign={'center'}
              fontWeight={800}>
              Choose your Challenge Bundle
            </Typography>

            <ChallengePlanSelection
              isChangePlanModal
              plans={flowPlans}
              variant={isChallengeBundleFlow ? 'bundle' : 'package'}
            />

            <Box />
            <Button
              style={{ width: '300px' }}
              disabled={
                !(
                  challengePackageSelectedPlan?.checkoutPlanId ??
                  challengePackageSelectedPlan?.id
                )
              }
              onClick={onConfirm}>
              Save
            </Button>
          </Stack>
        </ContentSection>
      </ContentWrapper>
    </Popup>
  );
};
